var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-wrapper',{attrs:{"space":"small"}},_vm._l((_vm.values),function(value){return _c('span',[(_vm.isObjectArray)?_c('submission-object-field',{attrs:{"value":value,"children":_vm.children}}):_c('submission-primitive-field',{attrs:{"lookup":_vm.lookup,"format":_vm.format,"value":value}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }